import { gql } from '@grandvisionhq/graphql';
import { commercialCategoryFragment, frameFeaturesFragment, lensFeaturesFragment } from './fragments/small-fragments.js';
import './fragments/prices/productPriceItem.js';
import './fragments/prices/productPrice.js';
import './fragments/offerings.js';
import { productFragment } from './fragments/product.js';
import { variantFragment } from './fragments/variant.js';

const GET_READY_READER_BY_SLUG = gql`
  query GetReadyReaderBySlug($slug: String!) {
    getProductBySlug(slug: $slug) {
      product {
        __typename
        ... on ReadyReaderProduct {
          id
          ...productFragment
          commercialCategories {
            ...CommercialCategoryFragment
          }
          variants {
            ...variantFragment
            variantTypeDetails {
              targetGender
              targetGenderAllLocales {
                locale
                value
              }
              frameFeatures {
                ...frameFeaturesFragment
              }
              lensFeatures {
                ...lensFeaturesFragment
              }
              channelAvailability
              power
              hasBlueFilter
            }
          }
        }
      }
    }
  }
  ${productFragment}
  ${commercialCategoryFragment}
  ${variantFragment}
  ${frameFeaturesFragment}
  ${lensFeaturesFragment}
`;

export { GET_READY_READER_BY_SLUG };
//# sourceMappingURL=get-ready-reader-by-slug.js.map
